// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "@rails/actioncable"
import "./controllers"
import "./controllers/layout_selector"

// Global toast service
import "./services/toast"

import "./services/vue_editors_loader"

// Register Service Worker for Web Push (requires HTTPS)
if ("serviceWorker" in navigator) {
	window.addEventListener("load", () => {
		navigator.serviceWorker.register("/service-worker").catch(() => {
			// Ignore registration errors (e.g. unsupported browser)
		})
	})
}
